module.exports = __webpack_public_path__ + "img/kofi_cup.e209896a.png";